import { format } from "date-fns";
import { utcToZonedTime } from "date-fns-tz";
import crypt from "./crypt";

const functions = {
	addZeros: function AddZeros(num, len) {
		var numberWithZeroes = String(num);
		var counter = numberWithZeroes.length;

		while (counter < len) {
			numberWithZeroes = "0" + numberWithZeroes;

			counter++;
		}
		return numberWithZeroes;
	},
	iniFimMes: function IniFimMes() {
		var date = new Date();
		var dataAtual = new Date(date.getFullYear(), date.getMonth() + 1, 0);
		var dia = functions.addZeros(dataAtual.getDate(), 2);
		var mes = functions.addZeros(dataAtual.getMonth() + 1, 2);
		var ano = dataAtual.getFullYear();
		var inicioMes = ano + "-" + mes + "-" + "01";
		var fimMes = ano + "-" + mes + "-" + dia;

		return { inicioMes, fimMes };
	},
	dateByString: function dateToString(date) {
		try {
			let formatted = date;
			return formatted.split("-").reverse().join("/"); //recorta a data usando de referencia o - inverte o array e coloca / no lugar da ,
		} catch (error) {}
	},
	primerioUltimoDiaDoAno: function IniFimAno(anoInformado) {
		const date = new Date();
		const ano = anoInformado || date.getFullYear();

		const primeiroDiaDoAno = "01/01/" + ano;
		const ultimoDiaDoAno = "31/12/" + ano;
		return { primeiroDiaDoAno, ultimoDiaDoAno };
	},
	databaseConfig: function databaseConfig() {
		let userDB = sessionStorage.getItem("userDB");

		if (userDB?.length > 0) {
			userDB = crypt(userDB, "decrypt");
		}

		return userDB;
	},
	sessionIdEmpresa: function auth() {
		let sessionIdEmpresa = sessionStorage.getItem("sessionIdEmpresa");

		if (sessionIdEmpresa?.length > 0) {
			sessionIdEmpresa = crypt(sessionIdEmpresa, "decrypt");
		}

		return sessionIdEmpresa;
	},

	strToCurrency: function strToCurrency(value) {
		const valor = new Intl.NumberFormat("pt-BR", {
			style: "currency",
			currency: "BRL",
		}).format(value);
		return valor;
	},
	formatarMoeda: function (valor) {
		try {
			//arruma o valor conforme digitado
			// remova todos os caracteres não numéricos //
			valor = valor.replace(/\D/g, "");
			// adicione os separadores de milhar e decimal // valor = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(valor / 100);
			valor = new Intl.NumberFormat("pt-BR", {
				minimumFractionDigits: 2,
			}).format(valor / 100);

			return valor;
		} catch (error) {
			return 0;
		}
	},
	formatToFloat: function (valor, fraction) {
		try {
			valor = valor.replace(/[^\d,]|(?<=,.*),/g, "");

			return valor;
		} catch (error) {
			return "0";
		}
	},
	parseNumber: function (str) {
		try {
			if (str.includes(",")) {
				const normalizedStr = str.replace(",", ".");

				return parseFloat(normalizedStr);
			} else {
				// Se não houver vírgula, tente converter diretamente
				return parseFloat(str);
			}
		} catch (error) {
			return 0;
		}
	},
	removePoint: function (str) {
		try {
			if (str.includes(".")) {
				const normalizedStr = str.replace(".", "");

				return normalizedStr;
			} else {
				// Se não houver vírgula, tente converter diretamente
				return str;
			}
		} catch (error) {
			return 0;
		}
	},
	formatInteger: function (valor) {
		try {
			//arruma o valor conforme digitado
			// remova todos os caracteres não numéricos //
			valor = valor.replace(/\D/g, "");
			// adicione os separadores de milhar e decimal // valor = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(valor / 100);

			valor = valor;

			return valor;
		} catch (error) {
			return 0;
		}
	},

	dateTimeToStrIso8601: function dateTimeToStrIso8601(value) {
		try {
			const timeZone = "UTC";
			const zonedDate = utcToZonedTime(value, timeZone);
			const dataFormatada = format(zonedDate, "dd/MM/yyyy HH:mm:ss");

			return dataFormatada;
		} catch (error) {
			return null;
		}
	},
	dateToStrIso: function dateTimeToStrIso8601(value) {
		const dataFormatada = value.toISOString().split("T")[0];

		return dataFormatada;
	},
	dateNow: function dateNow() {
		let dataAtual = new Date();
		let dataFormatada = dataAtual.toLocaleDateString();

		return dataFormatada;
	},
	timeNow: function timeNow() {
		const dataAtual = new Date();
		const opcoes = { timeZone: "America/Sao_Paulo" };
		const horaBrasilia = dataAtual.toLocaleTimeString("pt-BR", opcoes);

		return horaBrasilia;
	},
	dataTimeNow: function dateTimeNow() {
		const dataAtual = new Date();

		const opcoes = { timeZone: "America/Sao_Paulo" };
		const horaBrasilia = dataAtual.toLocaleTimeString("pt-BR", opcoes);

		let dataHoraFormatada = dataAtual.toLocaleDateString() + " " + horaBrasilia;

		return dataHoraFormatada;
	},
	getClientIP: async () => {
		try {
			const response = await fetch("https://api.ipify.org?format=json");
			const data = await response.json();
			return data.ip;
		} catch (error) {
			console.error("Failed to fetch client IP:", error);
			return null;
		}
	},

	pause: (ms) => {
		return new Promise((resolve) => setTimeout(resolve, ms));
	},
};

export default functions;

// const date = new Date();
// const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
// const lastDayDate = lastDay.toLocaleDateString();
// const lastDayDateiso = lastDay.toISOString();
// const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
// const firstDayDate = firstDay.toLocaleDateString();
